// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/Images/bg-left.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/Images/bg-right.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%2369707a%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%230057da%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@media (max-width: 767px) {
    .nav-link.me-3 {
      display: none;
    }
  }
  @media (max-width: 767px) {
    /* .nav-fixedOne {
      padding-bottom: 100px;
       Adjust the value to prevent overlapping
    } */
  
    footer.footer-admin {
      position: fixed;
      bottom: 0;
      width: 100%;
      text-align: center;
      background-color: #252525;
      z-index: 100; /* Ensure the footer is displayed above other content */
    }
}

#wrapper{
    padding:30px 15px;
    /* animate */
}
.animate {
    transition: all .3s ease-in-out;
}

.header-top {
    box-shadow: 0 3px 5px rgba(0, 0, 0, .1);
    background-color: #fff;
}
  /* Styles for mobile and tablet screens */
  @media (max-width: 468px) {
    .offcanvas-menu {
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      left: 0;
      transform: translateY(-100%);
      transition: transform 0.3s ease-in-out;
      background-color: #ffffff;
      z-index: 9999;
    }
  
    .Offcanvas-menu.open {
      transform: translateY(0);
    }
  }
.me-auto {
    margin-right: auto !important;
}
.me-3 {
    margin-right: 1rem !important;
}
*, *::before, *::after {
    box-sizing: border-box;
}
.input-group-joined.input-group-solid {
    border: 0;
    background-color: #eef2f8;
}
.input-group-joined {
    border-color: #c5ccd6;
    border-width: 1px;
    border-style: solid;
    border-radius: 0.4375rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.input-group {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    width: 100%;
}
*, *::before, *::after {
    box-sizing: border-box;
}
.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating), .input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3), .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control, .input-group:not(.has-validation) > .form-floating:not(:last-child) > .datatable-input, .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select, .input-group:not(.has-validation) > .form-floating:not(:last-child) > .datatable-selector {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.input-group-joined.input-group-solid .form-control, .input-group-joined.input-group-solid .datatable-input, .input-group-joined.input-group-solid .input-group-text {
    background-color: transparent;
}
.navbar .form-control, .navbar .datatable-input {
    font-size: 0.9rem;
}
.input-group-joined .form-control, .input-group-joined .datatable-input {
    border: none;
}
.input-group > .form-control, .input-group > .datatable-input, .input-group > .form-select, .input-group > .datatable-selector, .input-group > .form-floating {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0;
}
.nav-item a:hover{
    text-decoration: none;
}
.pe-0 {
    padding-right: 0 !important;
}
.form-control, .datatable-input {
display: block;
width: 100%;
font-size: 0.875rem;
font-weight: 400;
line-height: 1;
color: #69707a;
background-color: #fff;
background-clip: padding-box;
border: 1px solid #c5ccd6;
appearance: none;
border-radius: 0px;
transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.btn{
border-radius: 0px;
}
[type=search] {
outline-offset: -2px;
/* -webkit-appearance: textfield; */
}
.cls2{
background-color:#eef2f8 ;
}
.form-select{
border-radius: 0px;
}
input, button, select, optgroup, textarea {
margin: 0;
font-family: inherit;
font-size: inherit;
line-height: inherit;
}
*, *::before, *::after {
box-sizing: border-box;
}
.navbar-expand .navbar-nav {
flex-direction: row;
}
.ms-auto {
margin-left: auto !important;
}
.align-items-center {
align-items: center !important;
}

.feather {
height: 1rem;
width: 1rem;
vertical-align: top;
}

img, svg {
vertical-align: middle;
}
*, *::before, *::after {
box-sizing: border-box;
}
.dropdown .dropdown-toggle.show .dropdown-arrow {
transform: rotate(90deg);
}

.dropdown .dropdown-toggle .dropdown-arrow {
margin-left: 0.4rem;
margin-right: 0;
transition: transform 0.1s ease-in-out;
font-size: 0.6em;
}
ol, ul, dl {
margin-top: 0;
margin-bottom: 1rem;
}
ol, ul {
padding-left: 2rem;
}
*, *::before, *::after {
box-sizing: border-box;
}

/* ----------------- */
.topnav {
padding-left: 0;
height: 3.625rem;
z-index: 1039;
font-size: 0.9rem;
}
.shadow {
box-shadow: 0 0.15rem 1.75rem 0 rgba(33, 40, 50, 0.15) !important;
}
.justify-content-between {
justify-content: space-between !important;
}
.justify-content-sm-start {
justify-content: flex-start !important;
}
.navbar-expand {
flex-wrap: nowrap;
justify-content: flex-start;
}
.bg-white {
--bs-bg-opacity: 1;
background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}
.topnav.navbar-light .navbar-brand {
color: #363d47;
}
.me-auto {
margin-right: auto !important;
}
.me-3 {
margin-right: 1rem !important;
}
#layoutSidenav {
display: flex;
}
.nav-fixed #layoutSidenav #layoutSidenav_nav {
width: 15rem;
/* height: 100vh; */
z-index: 1038;
margin: 0px;


}
main{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    /* height: 90vh; */
    background-position: left top, right bottom;
    background-repeat: no-repeat, no-repeat;
    padding: 20px 0px;

}
.offcanvas-body {
    flex-grow: 1;
    /* padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x); */
    overflow-y: auto;
    padding: 0px;
}
.fixed-top, .nav-fixed #layoutSidenav #layoutSidenav_nav, .nav-fixed .topnav {
position: fixed;
top: 0;
right: 0;
left: 0;
background-color: #fff;
z-index: 1030;
}
#layoutSidenav  #layoutSidenav_nav {
/* flex-basis: 15rem; */
flex-shrink: 0;
transition: transform 0.15s ease-in-out;
width: 100%;
/* z-index: 1038;
transform: translateX(-15rem); */
}
.nav-fixed #layoutSidenav #layoutSidenav_nav .sidenav {
padding-top: 3.625rem;
}
.sidenav {
display: flex;
flex-direction: column;
height: 100%;
flex-wrap: nowrap;
font-size: 0.9rem;
}
.sidenav-light {
background-color: #fff;
color: #212832;
}
/* .shadow-right {
box-shadow: 0.15rem 0 1.75rem 0 rgba(33, 40, 50, 0.15) !important;
} */
.nav-fixed #layoutSidenav #layoutSidenav_nav .sidenav {
padding-top: 3.625rem;
}
.nav-fixed #layoutSidenav #layoutSidenav_nav .sidenav .sidenav-menu {
overflow-y: overlay;
overflow-x: hidden;
}

.sidenav-menu .newI{
width: 100%;
background: #fff;
margin-left: 15%;
/* z-index: 1000; */
position: inherit;
margin-top: 10px;
border-radius: 27px;
border: 1px solid rgba(52, 73, 94, 0.44);
padding: 4px;
}
.sidenav-menu .profile_info{
padding-top: 10px;
color: #536b9f;
font-weight: 300;

}
.sidenav .sidenav-menu {
flex-grow: 1;
}
.sidenav .sidenav-menu .nav {
flex-direction: column;
flex-wrap: nowrap;
text-align: center;
justify-content: space-around;
}
.nav {
--bs-nav-link-padding-x: 1rem;
--bs-nav-link-padding-y: 0.5rem;
--bs-nav-link-font-weight: ;
--bs-nav-link-color: var(--bs-link-color);
/* --bs-nav-link-hover-color: var(--bs-link-hover-color); */
--bs-nav-link-disabled-color: #69707a;
display: flex;
flex-wrap: wrap;
padding-left: 0;
margin-bottom: 0;
list-style: none;
}
.accordion {
--bs-accordion-color: #69707a;
--bs-accordion-bg: #fff;
--bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
--bs-accordion-border-color: var(--bs-border-color);
--bs-accordion-border-width: 1px;
--bs-accordion-border-radius: 0.35rem;
--bs-accordion-inner-border-radius: calc(0.35rem - 1px);
--bs-accordion-btn-padding-x: 1.25rem;
--bs-accordion-btn-padding-y: 1rem;
--bs-accordion-btn-color: #69707a;
--bs-accordion-btn-bg: var(--bs-accordion-bg);
--bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
--bs-accordion-btn-icon-width: 1.25rem;
--bs-accordion-btn-icon-transform: rotate(-180deg);
--bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
--bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
--bs-accordion-btn-focus-border-color: transparent;
--bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(0, 97, 242, 0.25);
--bs-accordion-body-padding-x: 1.25rem;
--bs-accordion-body-padding-y: 1rem;
--bs-accordion-active-color: #0057da;
--bs-accordion-active-bg: #e6effe;
}

.nav-item a{ 
    color: #424e71;
    text-decoration: none;
}
.nav-item a:hover{
    color: #fff;
    background-color: #25335b; 
}
.accordion li{
    border-bottom: 1px solid #f1f2f3;
    width: 100%;
}
.sidenav-light .sidenav-menu .nav-link.active .nav-link-icon {
color: #0061f2;
}
.sidenav .sidenav-menu .nav .nav-link .nav-link-icon {
font-size: 0.9rem;
padding-right: 0.5rem;
display: inline-flex;
}
.sidenav-light .sidenav-menu .nav-link .nav-link-icon {
color: #a7aeb8;
}
.nav .nav-link .nav-link-icon, .sidenav-menu .nav-link .nav-link-icon {
margin-right: 0.5rem;
}
*, *::before, *::after {
box-sizing: border-box;
}

.accordion li a:hover{
/* color: #0057da; */
/* font-size: larger; */
color: #fff !important
}
.sidenav .sidenav-footer {
display: flex;
flex-shrink: 0;
align-items: center;
padding-left: 0.75rem;
padding-right: 0.75rem;
height: 3.8rem;
}
.sidenav .sidenav-footer .sidenav-footer-content {
font-size: 0.9rem;
}
.nav-fixed #layoutSidenav #layoutSidenav_content {
padding-left: 15rem;
top: 3.625rem;
}
.nav-fixed #layoutSidenav #layoutSidenav_content {
padding-left: 15rem;
top: 3.625rem;
}
#layoutSidenav #layoutSidenav_content {
position: relative;
display: flex;
flex-direction: column;
justify-content: space-between;
min-width: 0;
flex-grow: 1;
min-height: calc(100vh - 3.625rem);
/* margin-left: -15rem; */
}
.py-10 {
padding-top: 1rem !important;
padding-bottom: 6rem !important;
}
.mb-4 {
margin-bottom: 1.5rem !important;
}

.px-4 {
padding-right: 1.5rem !important;
padding-left: 1.5rem !important;
}
.container, .container-fluid, .container-xxl, .container-xl, .container-lg, .container-md, .container-sm {
--bs-gutter-x: 1.5rem;
--bs-gutter-y: 0;
width: 100%;
padding-right: calc(var(--bs-gutter-x) * 0.5);
padding-left: calc(var(--bs-gutter-x) * 0.5);
margin-right: auto;
margin-left: auto;
}
.px-4 {
padding-right: 1.5rem !important;
padding-left: 1.5rem !important;
}
.footer-admin.footer-light {
color: #a7aeb8;
}
.footer-admin {
    background-color: #252525;
    width: 100%;
    /* height: 5.5rem; */
display: flex;
align-items: center;
}
.footerrowOne{
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
}
.footerrowOne ul li{
    padding: 3px 0;
    color:"#fff";
}
.mt-auto {
margin-top: auto !important;
}
.row {
--bs-gutter-x: 1.5rem;
--bs-gutter-y: 0;
display: flex;
flex-wrap: wrap;
margin-top: calc(-1 * var(--bs-gutter-y));
margin-right: calc(-0.5 * var(--bs-gutter-x));
margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.small {
font-size: 0.875em;
}
.sidenav .sidenav-menu .nav {
flex-direction: column;
flex-wrap: nowrap;
}


*, *::before, *::after {
box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/HeaderComponent/header.css"],"names":[],"mappings":";AACA;IACI;MACE,aAAa;IACf;EACF;EACA;IACE;;;OAGG;;IAEH;MACE,eAAe;MACf,SAAS;MACT,WAAW;MACX,kBAAkB;MAClB,yBAAyB;MACzB,YAAY,EAAE,uDAAuD;IACvE;AACJ;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;AACA;IAKI,+BAA+B;AACnC;;AAEA;IACI,uCAAuC;IACvC,sBAAsB;AAC1B;EACE,yCAAyC;EACzC;IACE;MACE,WAAW;MACX,YAAY;MACZ,eAAe;MACf,MAAM;MACN,OAAO;MACP,4BAA4B;MAC5B,sCAAsC;MACtC,yBAAyB;MACzB,aAAa;IACf;;IAEA;MACE,wBAAwB;IAC1B;EACF;AACF;IACI,6BAA6B;AACjC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,SAAS;IACT,yBAAyB;AAC7B;AACA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,wBAAwB;IACxB,wEAAwE;AAC5E;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,WAAW;AACf;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;AACA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,YAAY;AAChB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,2BAA2B;AAC/B;AACA;AACA,cAAc;AACd,WAAW;AACX,mBAAmB;AACnB,gBAAgB;AAChB,cAAc;AACd,cAAc;AACd,sBAAsB;AACtB,4BAA4B;AAC5B,yBAAyB;AAGzB,gBAAgB;AAChB,kBAAkB;AAClB,wEAAwE;AACxE;AACA;AACA,kBAAkB;AAClB;AACA;AACA,oBAAoB;AACpB,mCAAmC;AACnC;AACA;AACA,yBAAyB;AACzB;AACA;AACA,kBAAkB;AAClB;AACA;AACA,SAAS;AACT,oBAAoB;AACpB,kBAAkB;AAClB,oBAAoB;AACpB;AACA;AACA,sBAAsB;AACtB;AACA;AACA,mBAAmB;AACnB;AACA;AACA,4BAA4B;AAC5B;AACA;AACA,8BAA8B;AAC9B;;AAEA;AACA,YAAY;AACZ,WAAW;AACX,mBAAmB;AACnB;;AAEA;AACA,sBAAsB;AACtB;AACA;AACA,sBAAsB;AACtB;AACA;AACA,wBAAwB;AACxB;;AAEA;AACA,mBAAmB;AACnB,eAAe;AACf,sCAAsC;AACtC,gBAAgB;AAChB;AACA;AACA,aAAa;AACb,mBAAmB;AACnB;AACA;AACA,kBAAkB;AAClB;AACA;AACA,sBAAsB;AACtB;;AAEA,sBAAsB;AACtB;AACA,eAAe;AACf,gBAAgB;AAChB,aAAa;AACb,iBAAiB;AACjB;AACA;AACA,iEAAiE;AACjE;AACA;AACA,yCAAyC;AACzC;AACA;AACA,sCAAsC;AACtC;AACA;AACA,iBAAiB;AACjB,2BAA2B;AAC3B;AACA;AACA,kBAAkB;AAClB,4EAA4E;AAC5E;AACA;AACA,cAAc;AACd;AACA;AACA,6BAA6B;AAC7B;AACA;AACA,6BAA6B;AAC7B;AACA;AACA,aAAa;AACb;AACA;AACA,YAAY;AACZ,mBAAmB;AACnB,aAAa;AACb,WAAW;;;AAGX;AACA;IACI,kGAA6E;IAC7E,kBAAkB;IAClB,2CAA2C;IAC3C,uCAAuC;IACvC,iBAAiB;;AAErB;AACA;IACI,YAAY;IACZ,0EAA0E;IAC1E,gBAAgB;IAChB,YAAY;AAChB;AACA;AACA,eAAe;AACf,MAAM;AACN,QAAQ;AACR,OAAO;AACP,sBAAsB;AACtB,aAAa;AACb;AACA;AACA,uBAAuB;AACvB,cAAc;AACd,uCAAuC;AACvC,WAAW;AACX;gCACgC;AAChC;AACA;AACA,qBAAqB;AACrB;AACA;AACA,aAAa;AACb,sBAAsB;AACtB,YAAY;AACZ,iBAAiB;AACjB,iBAAiB;AACjB;AACA;AACA,sBAAsB;AACtB,cAAc;AACd;AACA;;GAEG;AACH;AACA,qBAAqB;AACrB;AACA;AACA,mBAAmB;AACnB,kBAAkB;AAClB;;AAEA;AACA,WAAW;AACX,gBAAgB;AAChB,gBAAgB;AAChB,mBAAmB;AACnB,iBAAiB;AACjB,gBAAgB;AAChB,mBAAmB;AACnB,wCAAwC;AACxC,YAAY;AACZ;AACA;AACA,iBAAiB;AACjB,cAAc;AACd,gBAAgB;;AAEhB;AACA;AACA,YAAY;AACZ;AACA;AACA,sBAAsB;AACtB,iBAAiB;AACjB,kBAAkB;AAClB,6BAA6B;AAC7B;AACA;AACA,6BAA6B;AAC7B,+BAA+B;AAC/B,2BAA2B;AAC3B,yCAAyC;AACzC,2DAA2D;AAC3D,qCAAqC;AACrC,aAAa;AACb,eAAe;AACf,eAAe;AACf,gBAAgB;AAChB,gBAAgB;AAChB;AACA;AACA,6BAA6B;AAC7B,uBAAuB;AACvB,8KAA8K;AAC9K,mDAAmD;AACnD,gCAAgC;AAChC,qCAAqC;AACrC,uDAAuD;AACvD,qCAAqC;AACrC,kCAAkC;AAClC,iCAAiC;AACjC,6CAA6C;AAC7C,gEAAsS;AACtS,sCAAsC;AACtC,kDAAkD;AAClD,8DAA8D;AAC9D,uEAA6S;AAC7S,kDAAkD;AAClD,yEAAyE;AACzE,sCAAsC;AACtC,mCAAmC;AACnC,oCAAoC;AACpC,iCAAiC;AACjC;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,gCAAgC;IAChC,WAAW;AACf;AACA;AACA,cAAc;AACd;AACA;AACA,iBAAiB;AACjB,qBAAqB;AACrB,oBAAoB;AACpB;AACA;AACA,cAAc;AACd;AACA;AACA,oBAAoB;AACpB;AACA;AACA,sBAAsB;AACtB;;AAEA;AACA,oBAAoB;AACpB,uBAAuB;AACvB;AACA;AACA;AACA,aAAa;AACb,cAAc;AACd,mBAAmB;AACnB,qBAAqB;AACrB,sBAAsB;AACtB,cAAc;AACd;AACA;AACA,iBAAiB;AACjB;AACA;AACA,mBAAmB;AACnB,aAAa;AACb;AACA;AACA,mBAAmB;AACnB,aAAa;AACb;AACA;AACA,kBAAkB;AAClB,aAAa;AACb,sBAAsB;AACtB,8BAA8B;AAC9B,YAAY;AACZ,YAAY;AACZ,kCAAkC;AAClC,yBAAyB;AACzB;AACA;AACA,4BAA4B;AAC5B,+BAA+B;AAC/B;AACA;AACA,gCAAgC;AAChC;;AAEA;AACA,gCAAgC;AAChC,+BAA+B;AAC/B;AACA;AACA,qBAAqB;AACrB,gBAAgB;AAChB,WAAW;AACX,6CAA6C;AAC7C,4CAA4C;AAC5C,kBAAkB;AAClB,iBAAiB;AACjB;AACA;AACA,gCAAgC;AAChC,+BAA+B;AAC/B;AACA;AACA,cAAc;AACd;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,oBAAoB;AACxB,aAAa;AACb,mBAAmB;AACnB;AACA;IAGI,aAAa;IAEb,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,YAAY;AAChB;AACA;AACA,2BAA2B;AAC3B;AACA;AACA,qBAAqB;AACrB,gBAAgB;AAChB,aAAa;AACb,eAAe;AACf,yCAAyC;AACzC,6CAA6C;AAC7C,4CAA4C;AAC5C;AACA;AACA,kBAAkB;AAClB;AACA;AACA,sBAAsB;AACtB,iBAAiB;AACjB;;;AAGA;AACA,sBAAsB;AACtB","sourcesContent":["\r\n@media (max-width: 767px) {\r\n    .nav-link.me-3 {\r\n      display: none;\r\n    }\r\n  }\r\n  @media (max-width: 767px) {\r\n    /* .nav-fixedOne {\r\n      padding-bottom: 100px;\r\n       Adjust the value to prevent overlapping\r\n    } */\r\n  \r\n    footer.footer-admin {\r\n      position: fixed;\r\n      bottom: 0;\r\n      width: 100%;\r\n      text-align: center;\r\n      background-color: #252525;\r\n      z-index: 100; /* Ensure the footer is displayed above other content */\r\n    }\r\n}\r\n\r\n#wrapper{\r\n    padding:30px 15px;\r\n    /* animate */\r\n}\r\n.animate {\r\n    -webkit-transition: all .3s ease-in-out;\r\n    -moz-transition: all .3s ease-in-out;\r\n    -o-transition: all .3s ease-in-out;\r\n    -ms-transition: all .3s ease-in-out;\r\n    transition: all .3s ease-in-out;\r\n}\r\n\r\n.header-top {\r\n    box-shadow: 0 3px 5px rgba(0, 0, 0, .1);\r\n    background-color: #fff;\r\n}\r\n  /* Styles for mobile and tablet screens */\r\n  @media (max-width: 468px) {\r\n    .offcanvas-menu {\r\n      width: 100%;\r\n      height: 100%;\r\n      position: fixed;\r\n      top: 0;\r\n      left: 0;\r\n      transform: translateY(-100%);\r\n      transition: transform 0.3s ease-in-out;\r\n      background-color: #ffffff;\r\n      z-index: 9999;\r\n    }\r\n  \r\n    .Offcanvas-menu.open {\r\n      transform: translateY(0);\r\n    }\r\n  }\r\n.me-auto {\r\n    margin-right: auto !important;\r\n}\r\n.me-3 {\r\n    margin-right: 1rem !important;\r\n}\r\n*, *::before, *::after {\r\n    box-sizing: border-box;\r\n}\r\n.input-group-joined.input-group-solid {\r\n    border: 0;\r\n    background-color: #eef2f8;\r\n}\r\n.input-group-joined {\r\n    border-color: #c5ccd6;\r\n    border-width: 1px;\r\n    border-style: solid;\r\n    border-radius: 0.4375rem;\r\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n}\r\n.input-group {\r\n    position: relative;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: stretch;\r\n    width: 100%;\r\n}\r\n*, *::before, *::after {\r\n    box-sizing: border-box;\r\n}\r\n.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating), .input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3), .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control, .input-group:not(.has-validation) > .form-floating:not(:last-child) > .datatable-input, .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select, .input-group:not(.has-validation) > .form-floating:not(:last-child) > .datatable-selector {\r\n    border-top-right-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n}\r\n\r\n.input-group-joined.input-group-solid .form-control, .input-group-joined.input-group-solid .datatable-input, .input-group-joined.input-group-solid .input-group-text {\r\n    background-color: transparent;\r\n}\r\n.navbar .form-control, .navbar .datatable-input {\r\n    font-size: 0.9rem;\r\n}\r\n.input-group-joined .form-control, .input-group-joined .datatable-input {\r\n    border: none;\r\n}\r\n.input-group > .form-control, .input-group > .datatable-input, .input-group > .form-select, .input-group > .datatable-selector, .input-group > .form-floating {\r\n    position: relative;\r\n    flex: 1 1 auto;\r\n    width: 1%;\r\n    min-width: 0;\r\n}\r\n.nav-item a:hover{\r\n    text-decoration: none;\r\n}\r\n.pe-0 {\r\n    padding-right: 0 !important;\r\n}\r\n.form-control, .datatable-input {\r\ndisplay: block;\r\nwidth: 100%;\r\nfont-size: 0.875rem;\r\nfont-weight: 400;\r\nline-height: 1;\r\ncolor: #69707a;\r\nbackground-color: #fff;\r\nbackground-clip: padding-box;\r\nborder: 1px solid #c5ccd6;\r\n-webkit-appearance: none;\r\n-moz-appearance: none;\r\nappearance: none;\r\nborder-radius: 0px;\r\ntransition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n}\r\n.btn{\r\nborder-radius: 0px;\r\n}\r\n[type=search] {\r\noutline-offset: -2px;\r\n/* -webkit-appearance: textfield; */\r\n}\r\n.cls2{\r\nbackground-color:#eef2f8 ;\r\n}\r\n.form-select{\r\nborder-radius: 0px;\r\n}\r\ninput, button, select, optgroup, textarea {\r\nmargin: 0;\r\nfont-family: inherit;\r\nfont-size: inherit;\r\nline-height: inherit;\r\n}\r\n*, *::before, *::after {\r\nbox-sizing: border-box;\r\n}\r\n.navbar-expand .navbar-nav {\r\nflex-direction: row;\r\n}\r\n.ms-auto {\r\nmargin-left: auto !important;\r\n}\r\n.align-items-center {\r\nalign-items: center !important;\r\n}\r\n\r\n.feather {\r\nheight: 1rem;\r\nwidth: 1rem;\r\nvertical-align: top;\r\n}\r\n\r\nimg, svg {\r\nvertical-align: middle;\r\n}\r\n*, *::before, *::after {\r\nbox-sizing: border-box;\r\n}\r\n.dropdown .dropdown-toggle.show .dropdown-arrow {\r\ntransform: rotate(90deg);\r\n}\r\n\r\n.dropdown .dropdown-toggle .dropdown-arrow {\r\nmargin-left: 0.4rem;\r\nmargin-right: 0;\r\ntransition: transform 0.1s ease-in-out;\r\nfont-size: 0.6em;\r\n}\r\nol, ul, dl {\r\nmargin-top: 0;\r\nmargin-bottom: 1rem;\r\n}\r\nol, ul {\r\npadding-left: 2rem;\r\n}\r\n*, *::before, *::after {\r\nbox-sizing: border-box;\r\n}\r\n\r\n/* ----------------- */\r\n.topnav {\r\npadding-left: 0;\r\nheight: 3.625rem;\r\nz-index: 1039;\r\nfont-size: 0.9rem;\r\n}\r\n.shadow {\r\nbox-shadow: 0 0.15rem 1.75rem 0 rgba(33, 40, 50, 0.15) !important;\r\n}\r\n.justify-content-between {\r\njustify-content: space-between !important;\r\n}\r\n.justify-content-sm-start {\r\njustify-content: flex-start !important;\r\n}\r\n.navbar-expand {\r\nflex-wrap: nowrap;\r\njustify-content: flex-start;\r\n}\r\n.bg-white {\r\n--bs-bg-opacity: 1;\r\nbackground-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;\r\n}\r\n.topnav.navbar-light .navbar-brand {\r\ncolor: #363d47;\r\n}\r\n.me-auto {\r\nmargin-right: auto !important;\r\n}\r\n.me-3 {\r\nmargin-right: 1rem !important;\r\n}\r\n#layoutSidenav {\r\ndisplay: flex;\r\n}\r\n.nav-fixed #layoutSidenav #layoutSidenav_nav {\r\nwidth: 15rem;\r\n/* height: 100vh; */\r\nz-index: 1038;\r\nmargin: 0px;\r\n\r\n\r\n}\r\nmain{\r\n    background-image: url(/src/Images/bg-left.png), url(/src/Images/bg-right.png);\r\n    /* height: 90vh; */\r\n    background-position: left top, right bottom;\r\n    background-repeat: no-repeat, no-repeat;\r\n    padding: 20px 0px;\r\n\r\n}\r\n.offcanvas-body {\r\n    flex-grow: 1;\r\n    /* padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x); */\r\n    overflow-y: auto;\r\n    padding: 0px;\r\n}\r\n.fixed-top, .nav-fixed #layoutSidenav #layoutSidenav_nav, .nav-fixed .topnav {\r\nposition: fixed;\r\ntop: 0;\r\nright: 0;\r\nleft: 0;\r\nbackground-color: #fff;\r\nz-index: 1030;\r\n}\r\n#layoutSidenav  #layoutSidenav_nav {\r\n/* flex-basis: 15rem; */\r\nflex-shrink: 0;\r\ntransition: transform 0.15s ease-in-out;\r\nwidth: 100%;\r\n/* z-index: 1038;\r\ntransform: translateX(-15rem); */\r\n}\r\n.nav-fixed #layoutSidenav #layoutSidenav_nav .sidenav {\r\npadding-top: 3.625rem;\r\n}\r\n.sidenav {\r\ndisplay: flex;\r\nflex-direction: column;\r\nheight: 100%;\r\nflex-wrap: nowrap;\r\nfont-size: 0.9rem;\r\n}\r\n.sidenav-light {\r\nbackground-color: #fff;\r\ncolor: #212832;\r\n}\r\n/* .shadow-right {\r\nbox-shadow: 0.15rem 0 1.75rem 0 rgba(33, 40, 50, 0.15) !important;\r\n} */\r\n.nav-fixed #layoutSidenav #layoutSidenav_nav .sidenav {\r\npadding-top: 3.625rem;\r\n}\r\n.nav-fixed #layoutSidenav #layoutSidenav_nav .sidenav .sidenav-menu {\r\noverflow-y: overlay;\r\noverflow-x: hidden;\r\n}\r\n\r\n.sidenav-menu .newI{\r\nwidth: 100%;\r\nbackground: #fff;\r\nmargin-left: 15%;\r\n/* z-index: 1000; */\r\nposition: inherit;\r\nmargin-top: 10px;\r\nborder-radius: 27px;\r\nborder: 1px solid rgba(52, 73, 94, 0.44);\r\npadding: 4px;\r\n}\r\n.sidenav-menu .profile_info{\r\npadding-top: 10px;\r\ncolor: #536b9f;\r\nfont-weight: 300;\r\n\r\n}\r\n.sidenav .sidenav-menu {\r\nflex-grow: 1;\r\n}\r\n.sidenav .sidenav-menu .nav {\r\nflex-direction: column;\r\nflex-wrap: nowrap;\r\ntext-align: center;\r\njustify-content: space-around;\r\n}\r\n.nav {\r\n--bs-nav-link-padding-x: 1rem;\r\n--bs-nav-link-padding-y: 0.5rem;\r\n--bs-nav-link-font-weight: ;\r\n--bs-nav-link-color: var(--bs-link-color);\r\n/* --bs-nav-link-hover-color: var(--bs-link-hover-color); */\r\n--bs-nav-link-disabled-color: #69707a;\r\ndisplay: flex;\r\nflex-wrap: wrap;\r\npadding-left: 0;\r\nmargin-bottom: 0;\r\nlist-style: none;\r\n}\r\n.accordion {\r\n--bs-accordion-color: #69707a;\r\n--bs-accordion-bg: #fff;\r\n--bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;\r\n--bs-accordion-border-color: var(--bs-border-color);\r\n--bs-accordion-border-width: 1px;\r\n--bs-accordion-border-radius: 0.35rem;\r\n--bs-accordion-inner-border-radius: calc(0.35rem - 1px);\r\n--bs-accordion-btn-padding-x: 1.25rem;\r\n--bs-accordion-btn-padding-y: 1rem;\r\n--bs-accordion-btn-color: #69707a;\r\n--bs-accordion-btn-bg: var(--bs-accordion-bg);\r\n--bs-accordion-btn-icon: url(data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%2369707a'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e);\r\n--bs-accordion-btn-icon-width: 1.25rem;\r\n--bs-accordion-btn-icon-transform: rotate(-180deg);\r\n--bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;\r\n--bs-accordion-btn-active-icon: url(data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%230057da'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e);\r\n--bs-accordion-btn-focus-border-color: transparent;\r\n--bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(0, 97, 242, 0.25);\r\n--bs-accordion-body-padding-x: 1.25rem;\r\n--bs-accordion-body-padding-y: 1rem;\r\n--bs-accordion-active-color: #0057da;\r\n--bs-accordion-active-bg: #e6effe;\r\n}\r\n\r\n.nav-item a{ \r\n    color: #424e71;\r\n    text-decoration: none;\r\n}\r\n.nav-item a:hover{\r\n    color: #fff;\r\n    background-color: #25335b; \r\n}\r\n.accordion li{\r\n    border-bottom: 1px solid #f1f2f3;\r\n    width: 100%;\r\n}\r\n.sidenav-light .sidenav-menu .nav-link.active .nav-link-icon {\r\ncolor: #0061f2;\r\n}\r\n.sidenav .sidenav-menu .nav .nav-link .nav-link-icon {\r\nfont-size: 0.9rem;\r\npadding-right: 0.5rem;\r\ndisplay: inline-flex;\r\n}\r\n.sidenav-light .sidenav-menu .nav-link .nav-link-icon {\r\ncolor: #a7aeb8;\r\n}\r\n.nav .nav-link .nav-link-icon, .sidenav-menu .nav-link .nav-link-icon {\r\nmargin-right: 0.5rem;\r\n}\r\n*, *::before, *::after {\r\nbox-sizing: border-box;\r\n}\r\n\r\n.accordion li a:hover{\r\n/* color: #0057da; */\r\n/* font-size: larger; */\r\ncolor: #fff !important\r\n}\r\n.sidenav .sidenav-footer {\r\ndisplay: flex;\r\nflex-shrink: 0;\r\nalign-items: center;\r\npadding-left: 0.75rem;\r\npadding-right: 0.75rem;\r\nheight: 3.8rem;\r\n}\r\n.sidenav .sidenav-footer .sidenav-footer-content {\r\nfont-size: 0.9rem;\r\n}\r\n.nav-fixed #layoutSidenav #layoutSidenav_content {\r\npadding-left: 15rem;\r\ntop: 3.625rem;\r\n}\r\n.nav-fixed #layoutSidenav #layoutSidenav_content {\r\npadding-left: 15rem;\r\ntop: 3.625rem;\r\n}\r\n#layoutSidenav #layoutSidenav_content {\r\nposition: relative;\r\ndisplay: flex;\r\nflex-direction: column;\r\njustify-content: space-between;\r\nmin-width: 0;\r\nflex-grow: 1;\r\nmin-height: calc(100vh - 3.625rem);\r\n/* margin-left: -15rem; */\r\n}\r\n.py-10 {\r\npadding-top: 1rem !important;\r\npadding-bottom: 6rem !important;\r\n}\r\n.mb-4 {\r\nmargin-bottom: 1.5rem !important;\r\n}\r\n\r\n.px-4 {\r\npadding-right: 1.5rem !important;\r\npadding-left: 1.5rem !important;\r\n}\r\n.container, .container-fluid, .container-xxl, .container-xl, .container-lg, .container-md, .container-sm {\r\n--bs-gutter-x: 1.5rem;\r\n--bs-gutter-y: 0;\r\nwidth: 100%;\r\npadding-right: calc(var(--bs-gutter-x) * 0.5);\r\npadding-left: calc(var(--bs-gutter-x) * 0.5);\r\nmargin-right: auto;\r\nmargin-left: auto;\r\n}\r\n.px-4 {\r\npadding-right: 1.5rem !important;\r\npadding-left: 1.5rem !important;\r\n}\r\n.footer-admin.footer-light {\r\ncolor: #a7aeb8;\r\n}\r\n.footer-admin {\r\n    background-color: #252525;\r\n    width: 100%;\r\n    /* height: 5.5rem; */\r\ndisplay: flex;\r\nalign-items: center;\r\n}\r\n.footerrowOne{\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-wrap: wrap;\r\n    flex-wrap: wrap;\r\n    margin-right: -15px;\r\n    margin-left: -15px;\r\n}\r\n.footerrowOne ul li{\r\n    padding: 3px 0;\r\n    color:\"#fff\";\r\n}\r\n.mt-auto {\r\nmargin-top: auto !important;\r\n}\r\n.row {\r\n--bs-gutter-x: 1.5rem;\r\n--bs-gutter-y: 0;\r\ndisplay: flex;\r\nflex-wrap: wrap;\r\nmargin-top: calc(-1 * var(--bs-gutter-y));\r\nmargin-right: calc(-0.5 * var(--bs-gutter-x));\r\nmargin-left: calc(-0.5 * var(--bs-gutter-x));\r\n}\r\n.small {\r\nfont-size: 0.875em;\r\n}\r\n.sidenav .sidenav-menu .nav {\r\nflex-direction: column;\r\nflex-wrap: nowrap;\r\n}\r\n\r\n\r\n*, *::before, *::after {\r\nbox-sizing: border-box;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
